// This condition guarantees that default value is true and only explicitly set to false disables the feature
export const ENABLE_MARKET_ORDER_TYPE = process.env.REACT_APP_ENABLE_MARKET_ORDER_TYPE !== 'false';

export const RETIREMENT_ACCOUNT_SUFFIX = '_Retirement';

export const ORDER_SIDE = {
  Buy: 0,
  Sell: 1,
};

export const UserRoles = {
  T7X_BypassMaintenance: 'T7X_BypassMaintenance',
};